import { BASE_DATETIME } from '@/utvStore/components/recommend/lp/commons'

import moment from 'moment'
const now = new moment()
const diffFromBase = now.diff(BASE_DATETIME, 'years')

const baseInfo = {
  id: 6,
  name: 'そまり百音',
  kana: 'そまりもね',
  roman: 'Somari mone',
  mainMethod: 'ねこ風水',
  mainMethodKana: 'ねこふうすい',
}

const additionalInfo = {
  description: `元アイドル占い師。数字に興味を持ち7歳から数秘術、タロット、西洋占星術、風水などを学ぶ。アイドル時代にライブ会場などで行っていた占いが評判を呼び、占い師として本格デビュー。鑑定歴は15年。こもれびのように降り注ぐ柔らかい声に包まれた本格鑑定が不思議な異空間へと導く。`,
  methods: 'ねこ風水（ねこふうすい）',
  yearsOfAppraisal: `15年`,
  appraisalNum: '1万人以上',
  managementOffice: {
    name: 'Luck Out',
    url: '',
  },
}

const forProfilePage = {
  realNameBornPlaceAge: '非公表',
  basicFortune: `/recommend/${baseInfo.id}/basic/input`,
  profileImage: '/static/img/recommend/lp/somarimone/profileImage1.png',
  // directAppraisal: {
  //   message: '占い師本人による直接鑑定は、現在WEBサービスでの特典（抽選制）でのみの受付となっています。詳細は各サービスの情報をご覧ください'
  // },
  digitalFortune: {
    name: '占いTV',
    url: '',
  },
  // salonTypeCommunity: {
  //   name: 'BaseCamp（月額制／毎月抽選での有料鑑定あり）',
  //   url: '',
  // }
}

const tellerList = {
  description: 'ふんわりした口調で鋭い真理を投げかける元アイドル占い師',
  thumbnail: '/static/img/recommend/lp/somarimone/counselor_160x160.png',
}

export default {
  ...baseInfo,
  ...additionalInfo,
  profilePage: forProfilePage,
  tellerList,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/info/profile.js